<div class="preset-designer" #designer *ngIf="client.canManage" [attr.aria-busy]="busy">
  <div class="preset-context">
    <div class="label">Underlying</div>
    <ets-symbol-picker [selectedInstrument]="selectedInstrument" [underlyings]="true" [showLastPrice]="false"
      [disabled]="busy || editing" (instrumentSelected)="changeUnderlying($event)"></ets-symbol-picker>
    <div class="label">Option Side</div>
    <dx-select-box [items]="optionSides" displayExpr="text" valueExpr="id" [value]="optionSideFilter"
      placeholder="Select Side" [acceptCustomValue]="false" [disabled]="busy || editing"
      (onValueChanged)="$event.event && changeOptionSide($event.value)"></dx-select-box>
    <div class="label">Preset</div>
    <dx-select-box [items]="filteredPresets" displayExpr="name" valueExpr="id" [value]="selectedId"
      placeholder="Select Preset" [searchEnabled]="false" [acceptCustomValue]="false" [disabled]="busy || editing || !optionSideFilter"
      (onValueChanged)="$event.event && select($event.value)"></dx-select-box>
  </div>
  <div class="preset-actions">
    <dx-button text="New" type="success" width="100%" (onClick)="create()" [disabled]="busy || editing || !underlying || !optionSideFilter"></dx-button>
    <dx-button text="Save" type="default" width="100%" (onClick)="save()" [disabled]="busy || !editing || !valid"></dx-button>
    <dx-button text="Edit" type="normal" width="100%" (onClick)="edit()" [disabled]="busy || editing || !draft"></dx-button>
    <dx-button text="Delete" type="danger" width="100%" (onClick)="remove()" [disabled]="busy || editing || !draft"></dx-button>
  </div>
  <hr class="preset-separator">
  <dx-scroll-view class="preset-content" [useNative]="false" showScrollbar="onHover">
  <div class="preset-scroll-content">
  <div *ngIf="!draft" class="preset-empty">Select an existing preset<br>or create a new one.</div>
  <div class="preset-error" role="alert" *ngIf="draft?.requiresReconfiguration">Requires Reconfiguration. Edit and Save This Preset Before Use.</div>
  <div *ngIf="draft" class="preset-fields">
    <div class="label">Preset Name</div>
    <dx-text-box [value]="draft.name" valueChangeEvent="input" [maxLength]="200" [readOnly]="!editing" [disabled]="busy"
      (onValueChanged)="$event.event && updateDraft({name: $event.value})"></dx-text-box>
    <div class="label">APG Spread Size</div>
    <dx-select-box [items]="apgSizes" displayExpr="text" valueExpr="value" [value]="draft.nominalApgWidth"
      [acceptCustomValue]="true" [searchEnabled]="true" [readOnly]="!editing" [disabled]="busy" placeholder="Select Size"
      (onCustomItemCreating)="onCustomApgSize($event)" (onValueChanged)="$event.event && updateDraft({nominalApgWidth: $event.value})"></dx-select-box>
    <div class="label">Option Side</div>
    <dx-select-box [items]="optionSides" displayExpr="text" valueExpr="id" [value]="draft.optionSide"
      placeholder="Select Side" [acceptCustomValue]="false" [readOnly]="!editing" [disabled]="busy"
      (onValueChanged)="$event.event && updateDraft({optionSide: $event.value})"></dx-select-box>
    <div class="label">Strategy</div>
    <dx-select-box [items]="strategies" displayExpr="text" valueExpr="id" [value]="draft.strategy"
      [readOnly]="!editing" [disabled]="busy" (onValueChanged)="$event.event && setStrategy($event.value)"></dx-select-box>
    <fieldset class="preset-settings fieldset" *ngIf="draft.strategy === 'butterfly'">
      <legend class="fieldset-title">Settings</legend>
      <div class="preset-context">
        <div class="label">IV Level</div>
        <dx-select-box [items]="ivLevels" displayExpr="text" valueExpr="id" [value]="draft.ivLevel"
          [readOnly]="!editing" [disabled]="busy" (onValueChanged)="$event.event && updateDraft({ivLevel: $event.value})"></dx-select-box>
      </div>
      <dx-button-group [items]="sizingModes" keyExpr="id" selectionMode="single" stylingMode="contained"
        [selectedItemKeys]="[draft.sizingMode]" [disabled]="!editing || busy" [class.preset-mode-readonly]="!editing && !busy"
        (onItemClick)="setMode($event.itemData.id)"></dx-button-group>
      <div class="preset-pair" *ngIf="draft.sizingMode === 'directWidth'">
        <div class="field">
          <div class="label">Offset From Shorts</div>
          <dx-number-box [value]="draft.offset" [inputAttr]="numericInputAttributes" [step]="10" [showSpinButtons]="true"
            valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
            (onValueChanged)="$event.event && updateDraft({offset: $event.value})"></dx-number-box>
        </div>
        <div class="field">
          <div class="label">Butterfly Width</div>
          <dx-number-box [value]="draft.width" [inputAttr]="numericInputAttributes" [step]="10" [min]="0" [showSpinButtons]="true"
            valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
            (onValueChanged)="$event.event && updateDraft({width: $event.value})"></dx-number-box>
        </div>
      </div>
      <ng-container *ngIf="draft.sizingMode === 'dynamicWidth'">
        <div class="field">
          <div class="label">Body Distance (% ATM Straddle)</div>
          <dx-number-box [value]="percentage" [inputAttr]="numericInputAttributes" format="#0.##'%'" [min]="0" [showSpinButtons]="true"
            valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
            (onValueChanged)="$event.event && setPercentage($event.value)"></dx-number-box>
        </div>
        <div class="field">
          <div class="label">Anchor Leg (% ATM Straddle)</div>
          <dx-number-box [value]="butterflyAnchorPercentage" [inputAttr]="numericInputAttributes" format="#0.##'%'" [showSpinButtons]="true"
            valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
            (onValueChanged)="$event.event && setButterflyAnchorPercentage($event.value)"></dx-number-box>
        </div>
        <div class="preset-pair">
          <div class="field">
            <div class="label">Min Offset From Shorts (Points)</div>
            <dx-number-box [value]="draft.minOffset" [inputAttr]="numericInputAttributes" [min]="0" [step]="10" [showSpinButtons]="true"
              valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
              (onValueChanged)="$event.event && updateDraft({minOffset: $event.value})"></dx-number-box>
          </div>
          <div class="field">
            <div class="label">Min Butterfly Width (Points)</div>
            <dx-number-box [value]="draft.floor" [inputAttr]="numericInputAttributes" [min]="10" [step]="10" [showSpinButtons]="true"
              valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy" [isValid]="floorValid" [validationError]="floorValidationError"
              (onValueChanged)="$event.event && updateDraft({floor: $event.value})"></dx-number-box>
          </div>
        </div>
      </ng-container>
    </fieldset>
    <div class="preset-error preset-settings" role="alert" *ngIf="draft.strategy === 'butterfly' && butterflyError">{{butterflyError}}</div>
    <fieldset class="preset-settings fieldset" *ngIf="draft.strategy === 'vertical' && draft.verticalSettings">
      <legend class="fieldset-title">Settings</legend>
      <dx-button-group
          [items]="verticalModes" keyExpr="id" selectionMode="single" stylingMode="contained"
          [selectedItemKeys]="[draft.verticalSettings.startMode]" [disabled]="!editing || busy" [class.preset-mode-readonly]="!editing && !busy"
          (onItemClick)="setVerticalMode($event.itemData.id)"></dx-button-group>
      <fieldset class="fieldset">
        <legend class="fieldset-title">Buy Leg (Anchor)</legend>
        <div class="field">
          <div class="label">{{draft.verticalSettings.startMode === 'fixed' ? 'Distance From Anchor (Points)' : 'Distance From Anchor (% ATM Straddle)'}}</div>
          <dx-number-box [value]="verticalStartValue" [inputAttr]="numericInputAttributes" [format]="verticalStartFormat"
            [step]="draft.verticalSettings.startMode === 'fixed' ? 10 : 1" [min]="0" [showSpinButtons]="true" valueChangeEvent="input"
            [readOnly]="!editing" [disabled]="busy" (onValueChanged)="$event.event && setVerticalStartValue($event.value)"></dx-number-box>
        </div>
        <div class="preset-pair" *ngIf="draft.verticalSettings.startMode === 'straddlePercentage'">
          <div class="field">
            <div class="label">Min Offset (Points)</div>
            <dx-number-box [value]="draft.verticalSettings.minOffset" [inputAttr]="numericInputAttributes" [step]="10" [min]="0" [showSpinButtons]="true"
              [showClearButton]="true" placeholder="No Minimum" valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
              (onValueChanged)="$event.event && updateVertical({minOffset: $event.value})"></dx-number-box>
          </div>
          <div class="field">
            <div class="label">Max Offset (Points)</div>
            <dx-number-box [value]="draft.verticalSettings.maxOffset" [inputAttr]="numericInputAttributes" [step]="10" [min]="0" [showSpinButtons]="true"
              [showClearButton]="true" placeholder="No Maximum" valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
              (onValueChanged)="$event.event && updateVertical({maxOffset: $event.value})"></dx-number-box>
          </div>
        </div>
      </fieldset>
      <fieldset class="fieldset">
        <legend class="fieldset-title">Sell Leg</legend>
        <div class="field">
          <div class="label">{{draft.verticalSettings.sellMode === 'fixedWidth' ? 'Spread Width (Points)' : 'Distance From Same Anchor (% ATM Straddle)'}}</div>
          <dx-number-box [value]="verticalSellValue" [inputAttr]="numericInputAttributes" [format]="verticalSellFormat"
            [step]="draft.verticalSettings.sellMode === 'fixedWidth' ? 10 : 1" [min]="0" [showSpinButtons]="true" valueChangeEvent="input"
            [readOnly]="!editing" [disabled]="busy" (onValueChanged)="$event.event && setVerticalSellValue($event.value)"></dx-number-box>
        </div>
        <div class="preset-pair" *ngIf="draft.verticalSettings.sellMode === 'straddlePercentage'">
          <div class="field">
            <div class="label">Min Width (Points)</div>
            <dx-number-box [value]="draft.verticalSettings.minWidth" [inputAttr]="numericInputAttributes" [step]="10" [min]="0" [showSpinButtons]="true"
              [showClearButton]="true" placeholder="No Minimum" valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
              (onValueChanged)="$event.event && updateVertical({minWidth: $event.value})"></dx-number-box>
          </div>
          <div class="field">
            <div class="label">Max Width (Points)</div>
            <dx-number-box [value]="draft.verticalSettings.maxWidth" [inputAttr]="numericInputAttributes" [step]="10" [min]="0" [showSpinButtons]="true"
              [showClearButton]="true" placeholder="No Maximum" valueChangeEvent="input" [readOnly]="!editing" [disabled]="busy"
              (onValueChanged)="$event.event && updateVertical({maxWidth: $event.value})"></dx-number-box>
          </div>
        </div>
      </fieldset>
      <div class="preset-error" role="alert" *ngIf="verticalError">{{verticalError}}</div>
    </fieldset>
  </div>
  </div>
  </dx-scroll-view>
  <div class="preset-footer" *ngIf="editing">
    <dx-button text="Discard changes" type="danger" width="100%" [disabled]="busy" (onClick)="cancel()"></dx-button>
  </div>
  <div class="preset-error" role="alert" *ngIf="error">{{error}}</div>
  <dx-load-panel [visible]="busy" [delay]="0" [container]="designer" [position]="{of: designer}"
    [shading]="true" [closeOnOutsideClick]="false" message="Loading…"></dx-load-panel>
</div>

